import { render } from "./DownloadRequest.vue?vue&type=template&id=709b941d"
import script from "./DownloadRequest.vue?vue&type=script&lang=js"
export * from "./DownloadRequest.vue?vue&type=script&lang=js"

import "./DownloadRequest.vue?vue&type=style&index=0&id=709b941d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__